export default __webpack_public_path__ + "static/media/290.5dd29496.png";